export default "__VITE_ASSET__13d97c32__"